import LoadingCircle from 'Atoms/Loaders/LoadingCircle';
import KexIconLoader from 'Kex/KexIconLoader';
import { styled } from 'stitches.config';
import BaseButtonStyled from './BaseButtonStyle';
import BaseButtonType from './BaseButtonType';

function Button({
  onClick,
  children,
  icon,
  disabled,
  type,
  size,
  css,
  isLoading,
  fullWidth,
}: BaseButtonType) {
  const Icon = icon && styled(KexIconLoader(icon.type));
  return (
    <StyledButton
      aria-label={children?.toString() || ''}
      size={size}
      css={css}
      color={type}
      {...(!disabled && onClick && { onClick })}
      disabled={isLoading ? true : disabled}
      fullWidth={fullWidth}
    >
      <StyledButtonText isLoading={isLoading}>
        {Icon && (
          <IconContainer>
            <Icon color={icon.color} size={icon.size} />{' '}
          </IconContainer>
        )}
        {children}
      </StyledButtonText>

      {isLoading && (
        <StyledLoadingCircle>
          <LoadingCircle
            size="s"
            color={'primary'}
            onBackground={true}
            isLoading={isLoading}
          />
        </StyledLoadingCircle>
      )}
    </StyledButton>
  );
}

const IconContainer = styled('div', {
  position: 'absolute',
  left: 24,
});

const StyledLoadingCircle = styled('div', {
  position: 'absolute',
});

const StyledButtonText = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  variants: {
    isLoading: {
      true: {
        opacity: 0,
      },
      false: {
        opacity: 1,
      },
    },
  },
});

const StyledButton = styled(BaseButtonStyled, {
  position: 'relative',
  overflow: 'hidden',
});

export default Button;
